import { render, staticRenderFns } from "./ReporteAsignacionCursosView.vue?vue&type=template&id=0ec6d4fe&scoped=true"
import script from "./ReporteAsignacionCursosView.vue?vue&type=script&lang=js"
export * from "./ReporteAsignacionCursosView.vue?vue&type=script&lang=js"
import style0 from "./ReporteAsignacionCursosView.vue?vue&type=style&index=0&id=0ec6d4fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec6d4fe",
  null
  
)

export default component.exports